module.exports = __webpack_public_path__ + "static/media/7-14.4fac25a7.mp3";